// The public demo copy (demo.mixexim.in, PM2 angel-isp-demo on a fake database; the old
// demo.laxmicablevision.in address only redirects there, but is still listed so the badge and logins
// show if it is ever served directly again; see docs/superpowers/specs/2026-10-23-crm-product-page-and-demo-design.md).
const DEMO_HOSTS = ['demo.mixexim.in', 'demo.laxmicablevision.in'];
export const IS_DEMO = typeof window !== 'undefined' && DEMO_HOSTS.includes(window.location.hostname);

// The GTPL section is Laxmi-only. Hidden on the demo and on every operator's own hostname, so only
// Laxmi's own addresses (and local dev) show it.
const LAXMI_HOSTS = ['crm.laxmicablevision.in', 'agent.laxmicablevision.in', 'app.laxmicablevision.in', 'www.laxmicablevision.in', 'laxmicablevision.in', 'localhost', '127.0.0.1'];
export const IS_LAXMI_HOST = typeof window === 'undefined' || LAXMI_HOSTS.includes(window.location.hostname);
export const HIDE_GTPL = !IS_LAXMI_HOST;

// The public demo is the product shop window, so it wears the Orvyn mark wherever
// the CRM would otherwise show the Laxmi Cable Vision app logo.
export const DEMO_BRAND = { name: 'Orvyn', logo: '/orvyn-mark.png?v=1' };

// Must match LOGINS / PASSWORD in backend/scripts/demo-seed.js.
export const DEMO_PASSWORD = 'demo1234';
export const DEMO_LOGINS = [
  { label: 'Admin', mobile: '9000000001' },
  { label: 'Office staff', mobile: '9000000004' },
  { label: 'Collection agent', mobile: '9000000002' },
  { label: 'Technician', mobile: '9000000003' },
  { label: 'Customer', mobile: '9000012345' },
];
